import isEmpty from 'lodash/isEmpty';

const ERROR_MESSAGE = 'Please select ';
export const DEFAULT_ERROR_BANNER_MESSAGE = 'Please fill above details';

export const ERROR_BANNER = 'errorATCBanner';
export const ERROR_CUSTOM_BANNER = 'errorATCCustomBanner';

const customDimensions = {
    CUSTOM_OPTIONS_FORM_ID_WD: 'width',
    CUSTOM_OPTIONS_FORM_ID_LN: 'length',
    CUSTOM_OPTIONS_FORM_ID_MNT: 'mount',
    // MO: 'Birthstones',
    // PER: 'Personalization',
};

export const parseBannerMessage = (dimensions) => {
    let errorATCMessage = '';

    if (dimensions.length > 2) {
        const lastWord = dimensions.pop();
        errorATCMessage = `${ERROR_MESSAGE + dimensions.join(', ')} and ${lastWord}`;
    } else if (dimensions.length === 2) {
        errorATCMessage = `${ERROR_MESSAGE + dimensions[0]} and ${dimensions[1]}`;
    } else {
        errorATCMessage = `${ERROR_MESSAGE} a ${dimensions[0]}`;
    }
    return errorATCMessage;
};

export const parseBannerCustomMessage = (customMessages) => {
    const widthLengthMNT = [];
    const customErrorDimensions = [];

    customMessages.forEach((item) => {
        if (customErrorDimensions.indexOf(item?.title.toLowerCase()) === -1) {
            customDimensions[item?.id]
                ? widthLengthMNT.push(customDimensions[item?.id])
                : customErrorDimensions.push(item?.title.toLowerCase());
        }
    });

    if (widthLengthMNT.length > 0) {
        return [
            customErrorDimensions.length > 0
                ? `${parseBannerMessage(widthLengthMNT)} and ${customErrorDimensions.join(' and')}`
                : parseBannerMessage(widthLengthMNT),
            widthLengthMNT,
        ];
    }
    return [customErrorDimensions.join(' and'), widthLengthMNT];
};

export const getErrorATCMessage = (messages) => {
    const errorMessageIndex = messages.findIndex((item) => item?.section === ERROR_BANNER);
    const customMessageIndex = messages.findIndex((item) => item?.section === ERROR_CUSTOM_BANNER);

    if (errorMessageIndex !== -1) {
        return customMessageIndex !== -1
            ? `${messages[0]?.message?.title} and ${messages[1]?.message?.title}`
            : messages[0]?.message?.title;
    }
    return messages[0]?.message?.title;
};
